export enum TourneyContestPhaseSubtype {
	Default,
	TeamQualifier
}
